// Raised when a stored project does not match the schemas. Its own type so the load path can
// tell it from a fetch failure: a missing template is a reason to open an empty editor, a
// drifted one is a reason to say so.
class InvalidProjectFormatError extends Error {
    constructor(reason: string) {
        super(reason);
        this.name = 'InvalidProjectFormatError';
    }
}

function isInvalidProjectFormatError(error: unknown): error is InvalidProjectFormatError {
    return error instanceof InvalidProjectFormatError;
}

export { InvalidProjectFormatError, isInvalidProjectFormatError };
